'use strict';

window.$a_jQuery(function($){
    var api_domain = window.attilus_config.api_domain;
    var api_path = window.attilus_config.api_path;

    window.apiSendData = function (request, url, callback_f, type_request) {
        $.ajax({
            url: api_domain + api_path + url,
            dataType: 'jsonp',
            type: type_request || 'GET',
            data: request,
            success: function (data) {
                console.log('success', url);
                callback_f(data);
            },
            error: function(a,b,c) {
                console.log('error',a,b,c);
            }
        });
    };

    window.apiGetDataDeliveryEarliest = function () {
        var request = {
            type: 'earliest',
            time_shift: 15,
            country_code: 'GB',
            domain: window.location.hostname
        };
        apiSendData(request, 'api_get_data_delivery.php', apiGetDataDeliveryEarliestResult);
    };

    window.apiGetDataDeliveryEarliestResult = function (data) {
        console.log('apiGetDataDeliveryEarliestResult: ', data);
        if (data && data.result) {
            for (var option_id in data.data) {
                var option_data = data.data[option_id];
                if (option_data) {
                    if (option_id === 'NOMINATED_DATE'){
                        $('.product-delivery-data').find('.product-delivery-type-nomdate-name').html(option_data.item_name);
                    }
                    if (option_id === 'LONDON_SAME_DAY'){
                        $('.product-delivery-data').find('.product-delivery-type-sameday-name').html(option_data.item_name);
                    }
                    if (option_id === 'LONDON_2H'){
                        $('.product-delivery-data').find('.product-delivery-type-express-name').html(option_data.item_name);
                    }

                    var option_block = $('.delivery-' + option_id);

                    var dateFormatted = window.getDateFormatted(option_data.date);

                    option_block.find('.earliest-date').html(dateFormatted ? dateFormatted[0] : option_data.date);
                    option_block.find('.earliest-date-y').html(dateFormatted ? dateFormatted[1] : option_data.date);

                    option_block.find('.product-delivery-type-name').html(option_data.item_name);

                    var time_shift = "00:15";
                    var time_duration = "2:00";
                    var interval = window.getEarliestInterval(option_data.time_from, time_shift, time_duration);
                    if (interval && typeof interval[1] !== 'undefined') {
                        option_block.find('.earliest-time').html(interval[1]);
                    }

                    var date_input = $('#date');
                    if (date_input.length) {
                        window.apiGetDataDeliveryEarliestResultAfter(date_input, option_data);
                    }
                }
            }
        }
    };



    window.apiGetDataDeliveryFull = function () {
        var request = {
            type: 'full',
            country_code: 'GB',
            domain: window.location.hostname
        };
        apiSendData(request, 'api_get_data_delivery.php', apiGetDataDeliveryFullResult);
    };

    window.apiGetDataDeliveryFullResult = function (data) {
        console.log('apiGetDataDeliveryFullResult: ', data);
        if (data && data.result) {

            if (typeof window.dataDeliveryReplaceText === 'function'){
                window.dataDeliveryReplaceText(data.data);
            } else {
                // console.error('dataDeliveryReplaceText is undefined');
            }

            for (var option_id in data.data) {
                var option_data = data.data[option_id];
                var option_block = $('.delivery-' + option_id);

                var is_active = option_data['active'];
                if (is_active) {
                    for (var day_of_week in option_data) {
                        if (day_of_week === 'active') {continue;}

                        var day_of_week_data = option_data[day_of_week];
                        switch (day_of_week) {
                            case '6':
                                option_block.find('.product-delivery-price-saturday').html(attilus_config.formatMoney(day_of_week_data.price).replace(".00", ""));
                                option_block.find('.delivery-price-saturday-attribute').val(day_of_week_data.price);
                                option_block.find('.delivery-threshold-attribute').val(day_of_week_data.free_delivery_threshold);
                                break;
                            case '0':
                                option_block.find('.product-delivery-price-sunday').html(attilus_config.formatMoney(day_of_week_data.price).replace(".00", ""));
                                option_block.find('.delivery-price-sunday-attribute').val(day_of_week_data.price);
                                option_block.find('.delivery-threshold-attribute').val(day_of_week_data.free_delivery_threshold);
                                break;
                            default:
                                option_block.find('.product-delivery-price-regular').html(attilus_config.formatMoney(day_of_week_data.price).replace(".00", ""));
                                option_block.find('.product-free-delivery-threshold').html(attilus_config.formatMoney(day_of_week_data.free_delivery_threshold).replace(".00", ""));

                                if (typeof day_of_week_data.total_price !== 'undefined'){
                                    setDeliveryPrice(day_of_week_data.total_price, day_of_week_data.total_price === 0);
                                }
                                option_block.find('.delivery-price-attribute')
                                    .val(typeof day_of_week_data.total_price !== 'undefined'
                                        ? day_of_week_data.total_price : day_of_week_data.price);
                                option_block.find('.delivery-price-regular-attribute').val(day_of_week_data.price);
                                option_block.find('.delivery-threshold-attribute').val(day_of_week_data.free_delivery_threshold);
                                option_block.find('.delivery-cutoff-time').html(day_of_week_data.cutoff_time);
                                option_block.find('.delivery-guaranteed-time').html(day_of_week_data.guaranteed_time);
                                if (typeof day_of_week_data.has_islands !== 'undefined' && day_of_week_data.has_islands) {
                                    option_block.find('.delivery-place-except-islands').addClass('visible');
                                } else {
                                    option_block.find('.delivery-place-except-islands').removeClass('visible');
                                }
                                break;
                        }
                    }
                } else {
                    option_block.hide();
                }
            }

//            var elements = $('.product-delivery-data-block:visible');
//            for (var i = 1 ; i < elements.length; i++) {
//                if (elements.eq(i).hasClass('product-delivery-data-block-header')) {
//                    if (elements.eq(i - 1).hasClass('product-delivery-data-block-header')) {
//                        elements.eq(i - 1).hide();
//                    }
//                    if (i === elements.length-1) {
//                        elements.eq(i).hide();
//                    }
//                }
//            }
        }
    };
    
    function resetDeliveryOptions() {
        var delivery_data_block = $('.product-delivery-data');

        delivery_data_block.find('.input-time-group').addClass('hidden');
        delivery_data_block.find('.time-from-to').data('time-from-to', '')
                .data('time-from', '').data('time-to', '')
                .val('');

        delivery_data_block.find('.eligible, .noteligible').addClass('hidden');

        var errors_block = delivery_data_block.find('.delivery-data-errors');
        errors_block.data('fixed', 0);

        errors_block.addClass('hidden').html('');
    }

    window.apiGetDataDeliveryByPostcode = function (postcode) {
        var request = {
            postcode: postcode ? postcode.encodeHTML() : '',
            time_shift: 15,
            type: 'by_code',
            country_code: 'GB',
            domain: window.location.hostname
        };
        $('.delivery-data-errors').data('errors', 0);
        $('.date-input').data('error-date', 0).removeClass('error-date');
        apiSendData(request, 'api_get_data_delivery.php', apiGetDataDeliveryByPostcodeResult);
    };

    window.apiGetDataDeliveryByPostcodeResult = function (data) {
        console.log('apiGetDataDeliveryByPostcodeResult: ', data);

        /**
         * Преобразование даты в текстовый формат
         * @param date - дата в формате 'mm-dd-YYYY'
         */
        function getDateStr(date) {
            if (typeof moment !== 'undefined') {
                var langToLang = {};
                var lang = $('html').attr('lang');
                var locate = langToLang[lang] ? langToLang[lang] : lang;
                var dilDate = moment(new Date(date.replace(/(\d{2}).(\d{2}).(\d{4})/, "$2/$1/$3")));
                date_str = dilDate.locale(locate).format('ddd, D MMM')
            }
        }

        var time_shift = "00:15";
        var time_duration = "2:00";
        resetDeliveryOptions();

        if (data && data.result) {
            for (var option_id in data.data) {
                var option_data = data.data[option_id];
                var option_block = $('.delivery-' + option_id);

                if (option_data) {

                    var dateFormatted = window.getDateFormatted(option_data.date);

                    option_block.find('.earliest-date').html(dateFormatted ? dateFormatted[0] : option_data.date);
                    option_block.find('.earliest-date-y').html(dateFormatted ? dateFormatted[1] : option_data.date);
                    option_block.find('.delivery-date-attribute').val(option_data.date);
                    option_block.find('.delivery-price-attribute').val(option_data.price);
                    option_block.find('.delivery-threshold-attribute').val(option_data.free_delivery_threshold);
                    option_block.find('.delivery-price-correction-attribute').val(option_data.price_correction);
                    option_block.find('.delivery-threshold-correction-attribute').val(option_data.free_delivery_threshold_correction);
                    option_block.find('.postcode-input-hidden').val(option_block.find('.postcode-input').val());

                    if (option_data.message) {
                        var message = '*' + option_data.message
                            .replace('#0', attilus_config.formatMoney(option_data.price_correction).replace(".00", ""))
                            .replace('#1', attilus_config.formatMoney(option_data.free_delivery_threshold).replace(".00", ""));
                        option_block.find('.delivery-price-diff').html(message);
                    }

                    var interval = window.getEarliestInterval(option_data.time_from, time_shift, time_duration);
                    if (interval && typeof interval[0] !== 'undefined' && typeof interval[1] !== 'undefined') {
                        option_block.find('.earliest-time').html(interval[1]);
                        option_block.find('.input-time-group').removeClass('hidden');
                        var interval_str = interval[0] + ' - ' + interval[1];

                        if (option_data.today){
                            var interval_time_to = window.getEarliestInterval(option_data.time_to, '0:00', '0:00');
                            var time_to = interval_time_to[0];
                            option_block.find('.eligible.before_').removeClass('hidden')
                                    .find('.workday-time-to').html(time_to);
                            option_block.find('.time-from-to').data('time-from-to', interval_str)
                                    .data('time-from', interval[0]).data('time-to', interval[1])
                                    .val(interval_str);
                        } else {
                            var date_str = '';

                            if (option_data.tomorrow) {
                                option_block.find('.earliest_date').html('tomorrow');
                                option_block.find('.eligible.after_').removeClass('hidden');
                                option_block.find('.time-from-to').data('time-from-to', interval_str)
                                        .data('time-from', interval[0]).data('time-to', interval[1])
                                        .val('Tomorrow' + ', ' + interval_str);
                            } else {
                                date_str = getDateStr(option_data.date);
                                option_block.find('.earliest_date').html(date_str);
                                option_block.find('.eligible.after_').removeClass('hidden');
                                option_block.find('.time-from-to').data('time-from-to', interval_str)
                                        .data('time-from', interval[0]).data('time-to', interval[1])
                                        .val(date_str + ', ' + interval_str);
                            }

                            // определение последнего рабочего дня
                            var interval_time_from = window.getEarliestInterval(option_data.time_from, '0:00', time_duration);
                            var time_from = interval_time_from[1];
                            option_block.find('.eligible.after_').find('.workday-time-from').html(time_from);
                            console.log('DEBUG: workday-time-from', time_from);

                            if (typeof option_data.last_delivery !== 'undefined') {
                                if (option_data.last_delivery.today) {
                                    option_block.find('.eligible.after_')
                                            .find('.working-day').removeClass('hidden');
                                    option_block.find('.eligible.after_')
                                            .find('.not-working-day').addClass('hidden');
                                } else {
                                    option_block.find('.eligible.after_')
                                            .find('.not-working-day').removeClass('hidden');
                                    option_block.find('.eligible.after_')
                                            .find('.working-day').addClass('hidden');
                                }


                                var interval_last_time_to = window.getEarliestInterval(option_data.last_delivery.time_to, '0:00', '0:00');
                                var last_time_to = interval_last_time_to[0];

                                option_block.find('.eligible.after_')
                                        .find('.latest-workday-time-to').html(last_time_to);

                            }
                        }
                    }
                    window.updateDeliveryPrice(option_id);
                }
            }
            showValidationErrors();
        } else {
        }

        if (typeof data.data !== 'undefined') {
            window.noDataErr(data.data);
        }
    };

    window.getEarliestInterval = function(time_from, time_shift, duration) {
        function splitTime(time_str) {
            var time_arr = time_str.toString().split(':',2);
            if (typeof time_arr[1] === 'undefined') {time_arr[1] = '00';}
            return time_arr;
        }

        function setTime(date, time_str, time_shift_str){
            var time_arr = splitTime(time_str);
            var time_shift_arr = typeof time_shift_str !== 'undefined' ? splitTime(time_shift_str) : ['00','00'];

            return new Date(date.setHours(parseInt(time_arr[0]) + parseInt(time_shift_arr[0]), parseInt(time_arr[1]) + parseInt(time_shift_arr[1]), 0));
        }

        function addTime(date, time_shift){
            var time_shift_arr = splitTime(time_shift);
            var date_time_arr = [date.getHours(), date.getMinutes()];

            return new Date(date.setHours(parseInt(time_shift_arr[0]) + parseInt(date_time_arr[0]), parseInt(time_shift_arr[1]) + parseInt(date_time_arr[1]), 0));
        }

        time_from = setTime(new Date(), time_from);

        var interval = [];
        var interval_str = [];

        interval[0] = time_from;
        interval[1] = addTime(new Date(time_from.getTime()), duration);

        interval_str[0] = ('0' + interval[0].getHours()).slice(-2) + ':' + ('0' + interval[0].getMinutes()).slice(-2);
        interval_str[1] = ('0' + interval[1].getHours()).slice(-2) + ':' + ('0' + interval[1].getMinutes()).slice(-2);

        return interval_str;
    };

    window.getTimeIntevals = function(time_from, time_to, time_step, duration) {
        time_from = new Date('01/01/1999 ' + time_from);
        time_to = new Date('01/01/1999 ' + time_to);

        var intervals = {};

        for (var time_i = new Date('01/01/1999 00:00:00'), i = 0;
             time_i <= time_to;
             time_i.setHours(time_i.getHours() + time_step)){

            if (time_i >= time_from){
                var time_i2 = new Date(time_i.getTime());
                var time_next = new Date(time_i.getTime());
                time_next.setHours(time_i.getHours() + time_step);

                if (time_next > time_to){
                    time_i2 = new Date(time_to.getTime());
                }

                time_i2.setHours(time_i.getHours() + duration);

                intervals[i] = [('0' + time_i.getHours()).slice(-2) + ':'
                    + ('0' + time_i.getMinutes()).slice(-2),
                    ('0' + time_i2.getHours()).slice(-2) + ':'
                    + ('0' + time_i2.getMinutes()).slice(-2)
                ];
                i++;
            }
        }

        return intervals;
    };

    /**
     * Преобразование строки к форматироуемому виду для заданной локали
     * см.: moment-with-locales.js
     * @param date - дата в формате "dd.mm.yyyy"
     * @param date_as_date
     */
    window.getDateFormatted = function (date, date_as_date){
        var result = {};

        if (typeof moment !== 'undefined' && typeof date !== 'undefined') {
            var langToLang = {};
            var lang = $('html').attr('lang');

            var locate = langToLang[lang] ? langToLang[lang] : lang;

            var optDate = date_as_date ? date : new Date(date.replace(/(\d{2}).(\d{2}).(\d{4})/, "$2/$1/$3"));
            var dilDate = moment(optDate);

            var todayDate = new Date();
            var tomorrowDate = new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate() + 1);

            var day = '';

            if(optDate.setHours(0,0,0,0) === todayDate.setHours(0,0,0,0)) {
                day = 'today';
            } else if (optDate.setHours(0,0,0,0) === tomorrowDate.setHours(0,0,0,0)){
                day = 'tomorrow';
            } else {
                day = dilDate.locale(locate).format('ddd');
            }

            result[0] = day + dilDate.locale(locate).format(', D MMM');
            result[1] = day + dilDate.locale(locate).format(', D MMM, YYYY');
        }
        return result;
    };

    window.apiGetDataDeliveryNominatedDate = function (date) {
        var request = {
            delivery_date: date ? date.encodeHTML() : '',
            time_shift: 15,
            type: 'nominated_date',
            country_code: 'GB',
            domain: window.location.hostname
        };
        $('.delivery-data-errors').data('errors', 0);
        $('.date-input').data('error-date', 0).removeClass('error-date');
        apiSendData(request, 'api_get_data_delivery.php', apiGetDataDeliveryNominatedDateResult);
    };

    window.apiGetDataDeliveryNominatedDateResult = function (data) {
        console.log('apiGetDataDeliveryNominatedDateResult: ', data);

        resetDeliveryOptions();

        if (data && data.result) {
            var option_data = data.data;
            var option_block = $('.delivery-' + option_data['delivery_type']);

            var dateFormatted = window.getDateFormatted(option_data.date);

            option_block.find('.delivery-date-attribute').val(option_data.date);
            option_block.find('.delivery-price-attribute').val(option_data.price);
            option_block.find('.delivery-price-regular-attribute').val(option_data.regular);
            option_block.find('.delivery-threshold-attribute').val(option_data.free_delivery_threshold);
            option_block.find('.delivery-price-correction-attribute').val(option_data.price_correction);
            option_block.find('.delivery-threshold-correction-attribute').val(option_data.free_delivery_threshold_correction);
            option_block.find('.postcode-input-hidden').val(option_block.find('.postcode-input').val());

            if (option_data.message) {
                var message = '**' + option_data.message
                    .replace('#0', attilus_config.formatMoney(option_data.price_correction).replace(".00", ""))
                    .replace('#1', attilus_config.formatMoney(option_data.free_delivery_threshold).replace(".00", ""));
                option_block.find('.delivery-price-diff').html(message);
            }

            if (typeof window.refreshCartForm === 'function') {
                window.refreshCartForm(false, 'NOMINATED_DATE');
            }
        }
    };

    window.apiGetDataDeliveryStorePickup = function (date) {
        var request = {
            delivery_date: date ? date.encodeHTML() : '',
            type: 'store_pickup',
            country_code: 'GB',
            domain: window.location.hostname
        };
        $('.delivery-data-errors').data('errors', 0);
        $('.date-input').data('error-date', 0).removeClass('error-date');
        apiSendData(request, 'api_get_data_delivery.php', apiGetDataDeliveryStorePickupResult);
    };

    window.apiGetDataDeliveryStorePickupResult = function (data) {
        console.log('apiGetDataDeliveryStorePickupResult: ', data);

        resetDeliveryOptions();

        if (data && data.result) {
            var option_data = data.data;
            var option_block = $('.delivery-' + option_data['delivery_type']);

            var dateFormatted = window.getDateFormatted(option_data.date);

            option_block.find('.delivery-date-attribute').val(option_data.date);
            option_block.find('.delivery-price-attribute').val(option_data.price);
            option_block.find('.delivery-threshold-attribute').val(option_data.free_delivery_threshold);
            option_block.find('.delivery-price-correction-attribute').val(option_data.price_correction);
            option_block.find('.delivery-threshold-correction-attribute').val(option_data.free_delivery_threshold_correction);
            option_block.find('.postcode-input-hidden').val(option_block.find('.postcode-input').val());

            if (option_data.message) {
                var message = '**' + option_data.message
                    .replace('#0', attilus_config.formatMoney(option_data.price_correction).replace(".00", ""))
                    .replace('#1', attilus_config.formatMoney(option_data.free_delivery_threshold).replace(".00", ""));
                option_block.find('.delivery-price-diff').html(message);
            }

            if (typeof window.refreshCartForm === 'function') {
                window.refreshCartForm(false, 'STORE_PICKUP');
            }
        }
    };


    window.apiLogDeliveryParams = function (data, callback) {
        console.log('apiLogDeliveryParams: ', data);
        var request = {
            delivery_params: data
        };
        apiSendData(request, 'log_delivery_params.php', callback);
    };

    window.noDataErr = function(data) {
        var options_arr = {};
        options_arr['LONDON_SAME_DAY'] = 'Same Day';
        options_arr['LONDON_2H'] = 'Express';

        var text_other_delivery = '';

        for (var option_id in data){
            if (data[option_id]) {
                //    text_other_delivery += ', but you can utilise the '+ options_arr[option_id] +' Delivery option to get your order faster';
                delete options_arr[option_id];
            } else {
                delete data[option_id];
            }
        }

        for (var option_id in options_arr){
            var delivery_option = $('.delivery-' + option_id);

            var attribute_delivery_postcode = $('.attributes-delivery-postcode');
            var attribute_delivery_date = $('.attributes-delivery-date');
            var attribute_delivery_time = $('.attributes-delivery-time');
            attribute_delivery_postcode.val('');
            attribute_delivery_date.val('');
            attribute_delivery_time.data('time-from','').data('time-to','').val('');

            delivery_option.find('.delivery-date-attribute').val('');
            delivery_option.find('.postcode-input-hidden').val('');
            delivery_option.find('.time-from-to').data('time-from-to', '')
                    .data('time-from', '').data('time-to', '')
                    .val('');

            delivery_option.find('.delivery-data-errors').addClass('hidden').data('errors',0);
            $('.date-input').data('error-date', 0).removeClass('error-date');

            window.setDeliveryPrice(0, false);
            delivery_option.find('.delivery-price-attribute').val('');

            /* Вывод ошибок в блок */
            if (data == false) {
                delivery_option.find('.noteligible.noteligible-all').removeClass('hidden');
            } else {
                delivery_option.find('.noteligible.noteligible-one').removeClass('hidden');
            }

            var errors_block = delivery_option.find('.delivery-data-errors');

            errors_block.addClass('hidden').html('');
            var error_text = 'Please choose an alternative delivery option';

            // data-fixed - для сохранения ошибки - 1 - не перезаписывать ошибку, а просто отобразить её
            errors_block.data('fixed', 1).html(
                "<span class='delivery-data-error-item'>" + error_text + "</span><br>"
            );

            errors_block.data('errors', 1);
        }
    };

    window.apiGetNotWorkingDates = function (delivery_type, country_code, callback) {
        var request = {
            delivery_type: delivery_type ? delivery_type.encodeHTML() : '',
            country_code: country_code ? country_code.encodeHTML() : '',
            domain: window.location.hostname
        };
        apiSendData(request, 'get_not_working_dates.php', callback);
    };

    window.apiGetPriceCorrectionsByDates = function (delivery_type, country_code, callback) {
        var request = {
            delivery_type: delivery_type ? delivery_type.encodeHTML() : '',
            country_code: country_code ? country_code.encodeHTML() : '',
            domain: window.location.hostname
        };
        apiSendData(request, 'get_price_corrections.php', callback);
    };

    window.apiGetEarliestDeliveryDate = function (delivery_type, country_code, callback) {
        console.log('apiLogDeliveryParams: ', data);
        var request = {
            delivery_type: delivery_type ? delivery_type.encodeHTML() : '',
            country_code: country_code ? country_code.encodeHTML() : '',
            domain: window.location.hostname
        };
        apiSendData(request, 'get_earliest_delivery_date.php', callback);
    };

    window.apiGetCountriesList = function (callback) {
        var request = {};
        apiSendData(request, 'get_countries_list.php', callback);
    };

    window.addEmailBackInStock = function (email, variant_id, callback) {
        console.log('addEmailBackInStock: ', email, variant_id);
        var request = {
            email: email ? email.encodeHTML() : '',
            variant_id: variant_id ? variant_id.encodeHTML() : ''
        };
        apiSendData(request, 'add_email_back_in_stock.php', callback);
    };

    window.apiSendRecaptcha = function (captcha, callback) {
        let request = {
            captcha: captcha
        };
        apiSendData(request, 'api_check_recaptcha.php', callback);
    };

    window.apiSendContactForm = function (data, callback) {
        let request = {
            name: data.name,
            email: data.email,
            phone: data.phone,
            body: data.body,
            captcha: data.captcha
        };
        apiSendData(request, 'api_contact_form_handler.php', callback);
    };


    window.loadCartTotalExcludingGiftCards = function(callback) {
        $.getJSON('/cart.js')
            .done(function(data) {
                let total = 0;
                let isGiftCardOnly = true;

                if (data.items && Array.isArray(data.items)) {
                    data.items.forEach(item => {
                        const isGiftCard = item.gift_card === true;

                        if (!isGiftCard) {
                            // Считаем сумму исходя из цены товара и количества
                            total += item.price * item.quantity;
                            isGiftCardOnly = false;
                        }
                    });
                }

                if (typeof callback === 'function') {
                    callback(total, isGiftCardOnly);
                }
            })
            .fail(function() {
                console.error('Failed to load cart data');
                if (typeof callback === 'function') {
                    callback(null);
                }
            });
    }
});
